export const colorImage = {
  beige: "../images/color-beige.svg",
  blue: "../images/color-blue.svg",
  green: "../images/color-green.svg",
  purple: "../images/color-purple.svg",
};
